export const ConfigurationOwnerUsernameLabel =
  'io.portainer.kubernetes.configuration.owner';

export const ConfigurationOwnerIdLabel =
  'io.portainer.kubernetes.configuration.owner.id';

export const PortainerNamespaceAccessesConfigMap = {
  namespace: 'portainer',
  configMapName: 'portainer-config',
  accessKey: 'NamespaceAccessPolicies',
};
